import { getDeviceInfo } from "@/api/smartTv";

const app =
  process.env.VUE_APP_SERVICE_TYPE === "NOW" ? "SpotvNow" : "SpotvNowGolf"; // NOW, GOLF

function buildUserAgent(info) {
  const appVersion = info.appVersion || "-";
  const platform = info.platform || "-";
  const osVersion = info.osVersion || "-";
  const deviceModel = info.modelName || "-";
  const deviceType = "TV";

  return `${app}/${appVersion} (${platform}; ${osVersion}; ${deviceType}; ${deviceModel})`;
}

const fallbackAgent = buildUserAgent({}); // "SpotvNow/- (-; -; TV; -)"

// 안전장치: 3초 내 device 정보가 없으면 폴백 (요청 무한 대기 방지)
const timeout = new Promise((resolve) =>
  setTimeout(() => resolve(fallbackAgent), 3000),
);

// device 정보를 앱당 한 번만 조회 (결과 캐싱)
const agentReady = Promise.race([
  getDeviceInfo()
    .then((info) => buildUserAgent(info))
    .catch((err) => {
      console.log("device info 실패:", err);
      return fallbackAgent;
    }),
  timeout,
]);

// 모든 요청이 나가기 직전 X-App-Agent 를 주입 → 첫 요청도 보장
export function attachAppAgent(instance) {
  instance.interceptors.request.use(async (config) => {
    config.headers["Spotv-Client-Info"] = await agentReady;
    return config;
  });
}
